import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveParticipationSubmissionStrategyType } from "@/generated/models/ApiWaveParticipationSubmissionStrategyType";
import { WAVE_IDENTITY_DUPLICATES_COPY, WAVE_IDENTITY_WHO_CAN_BE_SUBMITTED_COPY } from "@/helpers/waves/wave-submission-strategy.helpers";
function WaveIdentitySubmissionSpecsRow(t0) {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="tw-font-normal tw-text-iron-500">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <span className="tw-flex-1 tw-text-right tw-font-medium tw-text-iron-50">{value}</span>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-group tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-2 tw-px-2 tw-py-1 tw-text-sm">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function WaveIdentitySubmissionSpecsRows(t0) {
  const $ = _c(7);
  const {
    wave
  } = t0;
  const submissionStrategy = wave.participation.submission_strategy;
  if (!submissionStrategy) {
    return null;
  }
  if (submissionStrategy.type !== ApiWaveParticipationSubmissionStrategyType.Identity) {
    return null;
  }
  const eligibleIdentities = WAVE_IDENTITY_WHO_CAN_BE_SUBMITTED_COPY[submissionStrategy.config.who_can_be_submitted];
  const repeatSubmissions = WAVE_IDENTITY_DUPLICATES_COPY[submissionStrategy.config.duplicates];
  if (!eligibleIdentities || !repeatSubmissions) {
    return null;
  }
  let t1;
  if ($[0] !== eligibleIdentities.summary) {
    t1 = <WaveIdentitySubmissionSpecsRow label="Eligible identities" value={eligibleIdentities.summary} />;
    $[0] = eligibleIdentities.summary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== repeatSubmissions.summary) {
    t2 = <WaveIdentitySubmissionSpecsRow label="Repeat submissions" value={repeatSubmissions.summary} />;
    $[2] = repeatSubmissions.summary;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}